import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { RatePlanFindManyQueryInterface } from '@zaoblako/shared/modules/saas/dtos/rate-plan/rate-plan-find-many-query.dto';
import type { RatePlanPageInterface } from '@zaoblako/shared/modules/saas/dtos/rate-plan/rate-plan-page.dto';
import type { RatePlanFindOneQueryInterface } from '@zaoblako/shared/modules/saas/dtos/rate-plan/rate-plan-find-one-query.dto';
import type { RatePlanFindInterface } from '@zaoblako/shared/modules/saas/dtos/rate-plan/rate-plan-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisRatePlanService extends BaseService {
  protected baseUrl = '/basis/system/rate-plan';

  public findMany(queryParams?: RatePlanFindManyQueryInterface): Observable<RatePlanPageInterface> {
    return this.http.get<RatePlanPageInterface>(this.baseUrl, {
      params: queryParams
        ? this.objectToHttpParams(queryParams)
        : {}
    });
  }

  public findDefault(queryParams?: RatePlanFindOneQueryInterface): Observable<RatePlanFindInterface> {
    return this.http.get<RatePlanFindInterface>(`${this.baseUrl}/default`, {
      params: queryParams
        ? this.objectToHttpParams(queryParams)
        : {}
    });
  }

  public findManualDefault(queryParams?: RatePlanFindOneQueryInterface): Observable<RatePlanFindInterface> {
    return this.http.get<RatePlanFindInterface>(`${this.baseUrl}/manual-default`, {
      params: queryParams
        ? this.objectToHttpParams(queryParams)
        : {}
    });
  }

  public restoreOne(id: string): Observable<RatePlanFindInterface> {
    return this.http.post<RatePlanFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistory(id: string, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams
        ? this.objectToHttpParams(queryParams)
        : {}
    });
  }
}
